import React from "react";
import { useTranslation } from "react-i18next";
import close from "../../assets/images/close.png";

interface Iprops {
  heading: string;
  description?: string;
  yesButtonText?: string;
  noButtonText?: string;
  onClickOkay: () => void;
  onClickCancel: () => void;
  disabled?: boolean;
}

const ConfirmationModal: React.FC<Iprops> = (props) => {
  const { t: translation } = useTranslation();
  const {
    heading,
    description,
    yesButtonText = "Yes",
    noButtonText = "No",
    onClickOkay,
    onClickCancel,
    disabled,
  } = props;
  return (
    <div
      className="modal modal-custom-show"
      id="exampleModal"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center p-5 close-btn">
            <button
              type="button"
              className="btn-close close-inner theme-button"
              onClick={onClickCancel}
            >
              <img src={close} alt="" />
            </button>

            <h4 className="mb-3 space">
              <b>
                <span className="color-theme">{translation(heading)}</span>
              </b>
            </h4>
            <p className="mb-2">{translation(description as string)}</p>
            <div className="d-flex">
              <button
                className="theme-button black-btn-outline w-100"
                type="button"
                onClick={onClickCancel}
              >
                {noButtonText}
              </button>
              <button
                className="theme-button primary-btn w-100"
                type="button"
                onClick={() => onClickOkay()}
                disabled={disabled}
              >
                {yesButtonText}{" "}
                {disabled && (
                  <div className="spinner-border text-light" role="status" />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
